import sortedUniq from 'lodash/sortedUniq'

export const normalizeDocumentCategories = (
  values: ReadonlyArray<unknown>
): ReadonlyArray<string> => {
  return sortedUniq(
    values
      .filter((value): value is string => typeof value === 'string')
      .map((value) => value.trim().toLowerCase().replace(/\s+/g, '_'))
      .filter((cleaned) => cleaned !== '')
      .toSorted((a, b) => a.localeCompare(b))
  )
}
